import { useAuthStore } from '@/store/authStore';
import { useUserStore } from '@/store/userStore';
import { useCardsStore } from '@/store/cardsStore';
import { useSchemasStore } from '@/store/schemaStore';
import { useProfileStore } from '@/store/profileStore';
import { useWalletsStore } from '@/store/walletsStore';
import { useEventStreamStore } from '@/store/eventStreamStore';
import { useSuggestionsStore } from '@/store/suggestionsStore';
import { usePartnershipsStore } from '@/store/partnershipsStore';
import { useTransactionsStore } from '@/store/transactionsStore';
import { useCardProgramsStore } from '@/store/cardProgramsStore';
import { useCashAccountsStore } from '@/store/cashAccountsStore';
import { useContextSwitchStore } from '@/store/contextSwitchStore';
import { usePaymentOrdersStore } from '@/store/paymentOrdersStore';
import { useEntitlementsStore } from '@/store/entitlementsStore';
import { useExportsStore } from '@/store/exportsStore';
import { useAgreementsStore } from '@/store/agreementsStore';
import { useOpenPaymentsStatsStore } from '@/store/openPaymentsStatsStore';
import { useTeamSpaceStore } from '@/store/teamSpaceStore';
import { BroadcastMessageTypes, IDLE_TABS_SYNC_BROADCAST_CHANNEL } from '@/utils/general';

export const logoutAndResetAllStoresWithCid = () => {
  const authStore = useAuthStore();
  const userStore = useUserStore();
  const cardsStore = useCardsStore();
  const schemaStore = useSchemasStore();
  const profileStore = useProfileStore();
  const walletsStore = useWalletsStore();
  const trxStore = useTransactionsStore();
  const eventStreamStore = useEventStreamStore();
  const suggestionsStore = useSuggestionsStore();
  const cardProgramsStore = useCardProgramsStore();
  const partnershipsStore = usePartnershipsStore();
  const cashAccountsStore = useCashAccountsStore();
  const contextSwitchStore = useContextSwitchStore();
  const paymentOrdersStore = usePaymentOrdersStore();
  const entitlementsStore = useEntitlementsStore();
  const exportsStore = useExportsStore();
  const openPaymentsStatsStore = useOpenPaymentsStatsStore();
  const agreementsStore = useAgreementsStore();
  const teamSpaceStore = useTeamSpaceStore();

  trxStore.$reset();
  authStore.$reset();
  userStore.$reset();
  cardsStore.$reset();
  profileStore.$reset();
  walletsStore.$reset();
  eventStreamStore.$reset();
  suggestionsStore.$reset();
  partnershipsStore.$reset();
  cardProgramsStore.$reset();
  cashAccountsStore.$reset();
  contextSwitchStore.$reset();
  paymentOrdersStore.$reset();
  entitlementsStore.$reset();
  exportsStore.$reset();
  openPaymentsStatsStore.$reset();
  agreementsStore.$reset();
  teamSpaceStore.$reset();

  schemaStore.resetSchemasWithCid();

  /**
   * Keep the profileStore data for now as it only contains the communication language and
   * we can use it on logout to show the login page in the correct user language.
   */
  // profileStore.$reset();

  if (typeof localStorage !== 'undefined') {
    /**
     * Clearing the entire localStorage would also reset the theme selected by the user
     */
    localStorage.removeItem('currentContextUid');
    localStorage.removeItem('refreshTokenExp');
  }
  const bc = new BroadcastChannel(IDLE_TABS_SYNC_BROADCAST_CHANNEL);
  bc.postMessage({ type: BroadcastMessageTypes.Logout });
};
